import { PlusOutlined } from "@ant-design/icons";
import { Col, Modal, Row, Space, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { useState } from "react";
import AddOrUpdateFavoriteList from "./Components/AddOrUpdateFavoriList";
import FavoriteList from "./Components/FavoriteList";
import { useGetFavoriteList } from "./ServerSideStates";
import { useQueryClient } from "react-query";
import endPoints from "./EndPoints";
import PageTitle from "apps/Common/PageTitle";

const FavoriteAdsIndex = () => {
 
  const [isShowAddFavoriteModal, setIsShowAddFavoriteModal] = useState(false);
  const favoriteList = useGetFavoriteList();
  const queryClient = useQueryClient();
  return (
    <>
      <Col xs={24}>
        <Row gutter={[10, 20]} className="">
          {/* <Col span={24} className="!flex justify-center">
          <PageTitle
          title="Favoriler Listesi"
          count={favoriteList?.data?.data?.length || 0}
          />
            
          </Col> */}
          <Col xs={24} className="!flex justify-end">
            <MazakaButton
            
              className="!bg-black !text-white !text-xs !p-2 md:!p-4 md:!text-sm "
              onClick={() => {
                setIsShowAddFavoriteModal(true);
              }}
              icon={<PlusOutlined />}
              type="primary"
            >
              Liste Ekle
            </MazakaButton>
          </Col>
          <Col xs={24}>
            <FavoriteList />
          </Col>
        </Row>
      </Col>
      <Modal
        title="Liste Ekle"
        open={isShowAddFavoriteModal}
        onCancel={() => {
          setIsShowAddFavoriteModal(false);
        }}
        footer={false}
      >
        <AddOrUpdateFavoriteList
          onFinish={() => {
            setIsShowAddFavoriteModal(false);
            queryClient.resetQueries({
              queryKey: endPoints.getFavoriteListFilter,
              exact: false,
            });
          }}
        />
      </Modal>
    </>
  );
};

export default FavoriteAdsIndex;
